import { EventTarget } from 'cc';
import Cryptor from '../../Toolkit/Helper/Cryptor';

export type RequestSetting = {
    handleAllErrors?: boolean;
    expectedErrors?: string[];
    timeout?: number;
    noReply?: boolean;
};

export type RequestDataType = {
    Path: string;
    Data?: any;
    Subject?: string;
};

export type ResponseDataType = {
    Path: string;
    Data?: any;
    Subject?: string;
    ErrorCode?: number;
    Message?: string;

    // For backward compatibility
    Err?: string;
    Log?: string;
};

export enum NetworkEventType {
    START_CONNTECT = 'START_CONNNECT',
    CONNECTED = 'CONNECTED',
    DISCONNECTED = 'DISCONNECTED',
    START_RECONNECT = 'START_RECONNECT',
    RECONNECTED = 'RECONNECTED',
    ERROR = 'ERROR',
}

export default abstract class Network extends EventTarget {
    public static readonly EVENT_TYPE = NetworkEventType;

    constructor(
        protected url: string,
        protected readonly cryptor: Cryptor,
    ) {
        super();
    }

    public abstract open(): Promise<void>;
    public abstract reconnect(url?: string): Promise<void>;
    /**
     * 發送請求並等待回傳資料
     * @param path 路徑
     * @param postData 附帶資訊
     * @param setting 設定
     * @returns 回傳資料
     * @throws 預期的錯誤
     */
    public abstract send(path: string, postData: any, setting: RequestSetting, subject: string): Promise<any>;
    public abstract close(): void;
}
